import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { examinationSessionAttendeeLogList } from '../model/examinationSessionAttendeeLog.model';

@Injectable()
export class ExaminationSessionAttendeeLogsConnexionService extends KiwixiService {

    public api = environment.server + 'examinations_sessions_attendee_logs_connexion/';

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    getExaminationSessionAttendeeLogsConnexionById(_id): Observable<any> {
        const url = this.api + _id + '/';
        return this.getExaminationSessionAttendeeLogsConnexionByUrl(url);
    }

    getExaminationSessionAttendeeLogsConnexionByUrl(_url): Observable<any> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<any>(_url, {
            headers: header
        })
            .pipe(
                catchError(this.handleErrorObservable<any>(`getExaminationSessionAttendeeLogsConnexion`))
            );
    }

    getExaminationSessionAttendeeLogsConnexions(params: HttpParams): Observable<examinationSessionAttendeeLogList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<any>(this.api, {
            headers: header,
            params: params
        })
            .pipe(
                map(_ExaminationSessionAttendeeLogsConnexions => _ExaminationSessionAttendeeLogsConnexions),
                catchError(this.handleErrorObservable<any>(`getObservableExaminationSessionAttendeeLogsConnexions`))
            );
    }

    patchExaminationSessionAttendeeLogsConnexion(_id, params) {
        const url = this.api + _id + '/';
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.patch<any>(url, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<any>(`Création d'une fiche`)),
            );
    }

    getTypes() {
        return [
            {
                label: 'Déconnexion',
                code: 'disconnect',
                valid: true
            },
            {
                label: 'Connexion',
                code: 'connect',
                valid: true
            },
        ];
    }
}
